import React from 'react';
import { Navigate } from 'react-router-dom';

const AdminTradingBots: React.FC = () => {
  return <Navigate to="/admin/dashboard?tab=tradingBots" replace />;
};

export default AdminTradingBots;


